export default "__VITE_ASSET__DiK7a_4T__"